import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const getEntityListParams = (state: RootState) =>
  state?.detailsModel?.tableParams || {};

export const getDetails = (state: RootState, entityId: string) =>
  entityId ? state?.detailsModel?.details[entityId] : {};

export const getCurrentEntityId = (state: RootState) =>
  state?.detailsModel?.currentEntityId;

export const getNextEventAllowedAction = createSelector(
  [
    (state: RootState, id: string) =>
      (getDetails(state, id)?.allowedActions || []).map((action) => ({
        ...action,
        code: action?.allowedAction,
        name: action?.eventName,
      })),
    (state: RootState, entityId, domainType: string) => domainType,
  ],
  (allowedActions, domainType) =>
    domainType === 'activity'
      ? allowedActions.filter(({ linkedActivity }) => linkedActivity)
      : allowedActions,
);
